export default __webpack_public_path__ + "static/media/1516 knife block A top.452fb5e5.png";